import React, { forwardRef } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { HoverChild } from "UI/HoverChildren";

export const FnrToggleChild = forwardRef(
  (
    {
      children,
      disabled = false,
      selected = false,
      forceHover = false,
      killHoverStyles,
      style,
    },
    forwardedRef
  ) => {
    return (
      <HoverChild
        disabled={disabled}
        selected={selected}
        forceHover={forceHover}
        ref={forwardedRef}
        killHoverStyles={killHoverStyles}
        style={style}
      >
        <Wrapper
          whileTap={{ scale: disabled || selected ? 0.96 : 0.89 }}
          disabled={disabled}
          selected={selected}
          animate={{
            color: style?.color
              ? null
              : selected
              ? "#FFFFFF"
              : disabled
              ? "#828c8d"
              : "#475b68",
          }}
        >
          {children}
        </Wrapper>
      </HoverChild>
    );
  }
);

FnrToggleChild.displayName = "FnrToggleChild";

const Wrapper = styled(motion.div)`
  cursor: ${(props) =>
    props.disabled ? "not-allowed" : props.selected ? "auto" : "pointer"};
`;
